import "./js/navigation"
// utilities
import debounce from "./js/utilities/debounce"
// additions
import Sniffer from "./js/browser-sniffer"
import Overliner from "./js/components/overliner"
import SmoothScrollAnchors from "./js/jq-smooth-scroll"
import Accordion from "./js/components/accordion"
import Sticky from "./js/components/sticky"

window.addEventListener("load", function() {
	Sniffer.init()
	Overliner.init()
	SmoothScrollAnchors.bindEvents()
	Accordion.bindEvents()
	Sticky.bindEvents()
})

window.addEventListener(
	"resize",
	debounce(function() {
		Overliner.init()
	}, 90)
)
